import {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import InboxIcon from '@mui/icons-material/Inbox';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import {Box, Typography} from '@mui/material';

import InboxSection from './InboxSection';
import {Loading} from '../../../../../../components/Loading/Loading';
import {MatchStatus} from '../../../../../../types/MatchStatus/MatchStatus';
import {MatchData} from '../../../../../../types/shared-recruiting-types';

interface ListInboxSectionsProps {
  selected: string;
  selectedItems: MatchData[];
  isLoading: boolean;
  initialLoad: boolean;
  hasMore: boolean;
  companyId: string;
  initializeData: () => void;
  updateMatchTags: (status: string, match: MatchData) => void;
}

export default function ListInboxSections({
  selected,
  isLoading,
  initialLoad,
  hasMore,
  companyId,
  initializeData,
  updateMatchTags,
  selectedItems,
}: ListInboxSectionsProps) {
  const {t} = useTranslation();
  const [hasMoreTimeOut, setHasMoreTimeOut] = useState<boolean>(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setHasMoreTimeOut(hasMore);
    }, 2000);
    return () => clearTimeout(timeout);
  }, [hasMore]);

  const handleEmptyState = () => {
    return <Typography variant='h4'>{t('shared.noResults')}</Typography>;
  };

  const renderInboxSection = () => {
    if (selectedItems && selectedItems.length === 0 && !isLoading) {
      return handleEmptyState();
    }

    return selectedItems?.map((inboxItem) => {
      return (
        <InboxSection
          key={inboxItem.resourceId}
          inboxItem={inboxItem}
          icon={selected === MatchStatus.Accepted ? <InboxIcon fontSize='small' /> : <SyncAltIcon fontSize='small' />}
          selected={selected}
          companyId={companyId}
          initializeData={initializeData}
          updateMatchTags={updateMatchTags}
        />
      );
    });
  };

  if (initialLoad) {
    return (
      <Box
        sx={{
          minHeight: {xs: 'fit-content', sm: '437px', md: '447px'},
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          mt: {xs: 5, sm: 0},
        }}
      >
        <Loading />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {renderInboxSection()}
      {!hasMore && hasMoreTimeOut && <Typography variant='h4'>{t('shared.noMoreDataToLoad')}</Typography>}
      <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', my: 3}}>
        {isLoading && <Loading />}
      </Box>
    </Box>
  );
}
